import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import Button, { type ButtonProps } from '@/components/common/Button'

const SaveButton: React.FC<ButtonProps> = ({
  children,
  disabled,
  ref,
  ...props
}) => {
  return (
    <Button
      {...props}
      type={props.type ?? 'button'}
      disabled={disabled}
      className={twMerge(
        'flex items-center justify-center h-6 rounded-[4px]',
        props.className,
      )}
    >
      <span className="text-[13px]">Save</span>
    </Button>
  )
}

SaveButton.displayName = 'RichTextArea.SaveButton'

export { SaveButton }
